import { render, staticRenderFns } from "./OrdersShow.vue?vue&type=template&id=c591ef94&"
import script from "./OrdersShow.vue?vue&type=script&lang=js&"
export * from "./OrdersShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports